import { render, staticRenderFns } from "./deviceInspectionRecord.vue?vue&type=template&id=63484c32&scoped=true&"
import script from "./deviceInspectionRecord.vue?vue&type=script&lang=js&"
export * from "./deviceInspectionRecord.vue?vue&type=script&lang=js&"
import style0 from "./deviceInspectionRecord.vue?vue&type=style&index=0&id=63484c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63484c32",
  null
  
)

export default component.exports